const RISK_ANALYSIS_TIME_ZONE = "Europe/Copenhagen";

const localDateFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: RISK_ANALYSIS_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const localHourFormatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: RISK_ANALYSIS_TIME_ZONE,
  hour: "2-digit",
  hour12: false,
});

export const parseUtcDateTime = (value) => {
  if (!value) return null;

  const normalizedValue = String(value).trim();
  if (!normalizedValue) return null;

  const hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalizedValue);
  const isoLikeValue = normalizedValue.includes("T")
    ? normalizedValue
    : normalizedValue.replace(" ", "T");
  const utcValue = hasTimeZone ? isoLikeValue : `${isoLikeValue}Z`;
  const parsedDate = new Date(utcValue);

  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const getLocalDateTimeParts = (utcValue) => {
  const parsedDate = parseUtcDateTime(utcValue);
  if (!parsedDate) return { date: "", hour: null };

  const date = localDateFormatter.format(parsedDate);
  const hour = Number(localHourFormatter.format(parsedDate));

  return {
    date,
    hour: Number.isFinite(hour) ? hour : null,
  };
};

export const getLocalDateOrFallback = (utcValue, fallbackValue = "") => {
  const { date } = getLocalDateTimeParts(utcValue);
  return date || String(fallbackValue ?? "").substring(0, 10);
};

export const getLocalHourOrFallback = (utcValue, fallbackTimeValue = "") => {
  const { hour } = getLocalDateTimeParts(utcValue);
  if (hour !== null) return hour;

  const timePart = String(fallbackTimeValue ?? "").split(" ")[1] ?? String(fallbackTimeValue ?? "");
  const parsedHour = Number(String(timePart).split(":")[0]);
  return Number.isFinite(parsedHour) ? parsedHour : null;
};
